import { render, staticRenderFns } from "./FormPullout.vue?vue&type=template&id=b879f960&scoped=true&"
import script from "./FormPullout.vue?vue&type=script&lang=js&"
export * from "./FormPullout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b879f960",
  null
  
)

export default component.exports